export let config = {
  hideHealthyFoodHint: true,
  hideSportRewardHint: false,
  showFinishLevelEveryTime: true,
}
